import { useEffect, useState } from 'react'

/**
 * Turns true one frame after the component is on screen, so CSS transitions
 * from the server-rendered (hidden) state always get a chance to run.
 */
export const useMounted = (delay = 0): boolean => {
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        let frame = 0
        let timer: ReturnType<typeof setTimeout> | undefined

        frame = requestAnimationFrame(() => {
            frame = requestAnimationFrame(() => {
                if (delay > 0) timer = setTimeout(() => setMounted(true), delay)
                else setMounted(true)
            })
        })

        return () => {
            cancelAnimationFrame(frame)
            if (timer) clearTimeout(timer)
        }
    }, [delay])

    return mounted
}
